import styled from "styled-components";
import { COLOR } from '../../../../helpers/theme';
import React, { useEffect, useState } from "react";
import BookingCreateRooms from './BookingCreateRooms';
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../../components/layouts/Card";
import BookingCreateIssuer from './BookingCreateIssuer';
import { RootState } from '../../../../redux/rootReducers';
import Button from '../../../../components/forms/ButtonEx';
import BookingCreateActivity from './BookingCreateActivity';
import BookingCreateApplicant from './BookingCreateApplicant';
import BookingCreateInventory from './BookingCreateInventory';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageWrapper from "../../../../components/layouts/PageWrapper";
import { BootstrapGrid } from "../../../../components/layouts/BootstrapGrid";
import { getUserAsync } from '../../../../redux/reducers/users/users.actions';
import { getRoleAsync } from '../../../../redux/reducers/roles/roles.actions';
import { getRoomAsync, resetState } from '../../../../redux/reducers/rooms/rooms.actions';
import { getInventoryAsync } from '../../../../redux/reducers/inventories/inventories.actions';
import { createBookingAsync, selectBookingAsync, setBooking } from "../../../../redux/reducers/bookings/actions";

const BookingCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const booking = useSelector((state: RootState) => state.booking.updatedBooking);
  const selectedBooking = useSelector((state: RootState) => state.booking.selectedBooking);
  const [formTitle, setFormTitle] = useState<string>("Tambah");

  const populateData = () => {
    const paths = location.pathname.split("/");
    if (paths[3] === 'create') {
      dispatch(setBooking({
        issuer_name: '',
        issuer_phone: '',
        estimate_participant: 0,
        start_date: '',
        end_date: '',
        notes: '',
        id_user: 0,
        id_role: 0,
        description: '',
        rooms: [],
        status: 0,
        inventories: []
      }));
    } else {
      const bookingId = parseInt(paths[2]);
      if (bookingId && !isNaN(bookingId)) {
        dispatch(selectBookingAsync.request({ id: bookingId }));
        setFormTitle('Ubah');
      } else {
        navigate(`/building-management/bookings/create`);
      }
    }
  }

  useEffect(() => {
    populateData();
  }, [location.pathname]);

  useEffect(() => {
    dispatch(resetState());
    dispatch(getUserAsync.request({}));
    dispatch(getRoleAsync.request({}));
    dispatch(getRoomAsync.request({}));
    dispatch(getInventoryAsync.request({}));
  }, [selectedBooking]);

  const actionCreate = () => {
    if (!booking) return;
    dispatch(createBookingAsync.request(booking));
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="col-lg-4">
          <BookingCreateActivity />
          <BookingCreateApplicant />
          <BookingCreateIssuer />
        </div>
          
          
        <div className="col-lg-8">
          <BookingCreateRooms />
          <BookingCreateInventory />
          
          <Card>
            <div className="card--title">
              <h2 className="card--title-title">Konfirmasi Peminjaman</h2>
            </div>
            <div className="card--body">
              <p>Dengan menekan tombol dibawah, Anda setuju Suspendisse risus felis, elementum eget venenatis rhoncus, lacinia non est. Nam vulputate, nibh vel tempor elementum, augue ipsum rutrum tellus, vitae laoreet ipsum felis sit amet massa. Nulla suscipit blandit consectetur. Aliquam quis semper massa.</p>
              <div className="formSubmit">
                <Button
                  noBlock 
                  disabled={isLoading}
                  isLoading={isLoading}
                  onClick={actionCreate}
                  caption={`${formTitle} Peminjaman`}
                />
              </div>
            </div>
          </Card>
        </div>
      </React.Fragment>
    )
  }

  const renderCreated = () => {
    return (
      <React.Fragment>
        <div className="col-lg-4"></div>
        <div className="col-lg-4">
          <Card>
            <div className="card--title">
              <h2 className="card--title-title">{formTitle} Ruangan</h2>
            </div>
            <div className="card--body">
            <React.Fragment>
              <div className="formSuccess">
                {/* <h3>Permintaam peminjaman aset untuk kegiatan <b>{ createdBooking?.description }</b> berhasil dibuat!</h3> */}
              </div>
              <div className="formSubmit">
                <Link to='/building-management/bookings'>
                  <Button caption="Kembali ke Daftar Peminjaman Aset" />
                </Link>
                {/* <p>atau <Link to={`/building-management/bookings/${createdBooking?.id}`} className="formSubmit--update">ubah data peminjaman aset</Link></p> */}
              </div>
            </React.Fragment>
            </div>
          </Card>
        </div>
        <div className="col-lg-4"></div>
      </React.Fragment>
    )
  }
 
  return (
    <PageWrapper>
      <BookingCreatePageWrapper>
        <BootstrapGrid>
          <div className="row">
            { renderForm() }
          </div>
        </BootstrapGrid>
      </BookingCreatePageWrapper>
    </PageWrapper>
  );
}

const BookingCreatePageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;

  & .formTitle {
    margin-bottom: 10px;
  }

  & .formLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    & > .formLoading--caption {
      font-size: 14px;
      margin-top: -3px;
      margin-left: 10px;
    }
  }

  & .formSuccess {
    & > h3 {
      font-size: 14px;
      font-weight: normal;
      text-align: center;
    }
  }
  
  & .formSubmit {
    margin-top: 20px;
    text-align: center;

    & > p {
      margin-top: 5px;
      & > .formSubmit--update {
        cursor: pointer;
        color: ${COLOR.SECONDARY}
      }
    }
  }
`;

export default BookingCreatePage;